import BillingRepository from '../repositories/BillingRepository';
import { diContainer, serviceNames } from '../diContainer/diContainer';
import TransactionRepository from '../repositories/TransactionRepository';
import { FIELD_TYPE } from '../constants/Constants';
import SelectBillingAddressUseCase from './SelectBillingAddressUseCase';
import Address from '../domain/entities/Address';

class ToggleBillingSameAsShippingUseCase {
  private billingRepository: BillingRepository;

  private transactionRepository: TransactionRepository;

  private isSameAsShipping: boolean;

  constructor(isSameAsShipping: boolean) {
    this.isSameAsShipping = isSameAsShipping;
    this.billingRepository = diContainer.get(serviceNames.billingRepository);
    this.transactionRepository = diContainer.get(serviceNames.transactionRepository);
  }

  public async execute(): Promise<void> {
    const transaction = await this.transactionRepository.getTransaction();

    if (!this.isSameAsShipping) {
      transaction.setBillingAddress(transaction.shippingAddress);
      if (!transaction.shippingAddress.isNewAddress) {
        await this.billingRepository.selectAddress(transaction.shippingAddress.id);
        this.transactionRepository.loadTransaction();
      }
    } else {
      if (!transaction?.billingAddress.isNewAddress) {
        this.billingRepository.formStore.clearStore();
        if (transaction?.user?.isProCustomer) {
          this.billingRepository.formStore.setFieldValue(FIELD_TYPE.FIRST_NAME, transaction.user.firstName);
          this.billingRepository.formStore.setFieldValue(FIELD_TYPE.LAST_NAME, transaction.user.lastName);
        }
      } else {
        await new SelectBillingAddressUseCase(Address.NEW_ADDRESS_ID).execute();
      }
    }
  }
}

export default ToggleBillingSameAsShippingUseCase;
